import { render, staticRenderFns } from "./EditorTimestamp.vue?vue&type=template&id=0b9178df&scoped=true&"
import script from "./EditorTimestamp.vue?vue&type=script&lang=js&"
export * from "./EditorTimestamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9178df",
  null
  
)

export default component.exports